import apiAxios from "helpers/apiAxios";
import { isoToDate } from "./IsoDateInput";

// Posted vendor invoices in AX (GET /api/v1/vendorinvoices through Portal).
// params: { invoice_account, purch_id, invoice_id, invoice_date_from, invoice_date_to, payment_request_id }
// => [{ key, inv_no, inv_date, vendor_account, vendor_name, purch_id, currency, amount, vat, total,
//       description, lines: [...], used_by? }]
export const searchErpInvoices = (params) =>
  apiAxios
    // AX computes every invoice line: can take longer than the default 30 s timeout.
    .get("/erp/payment_requests/erp_invoice_search", { params, skipErrorToast: true, timeout: 60000 })
    .then((r) => r.data?.data || []);

export const SUPPORTED_CURRENCIES = ["VND", "USD"];

// One AX invoice = one request line (a single-vendor request allows one line per
// invoice number). VND/USD = amount before tax, VAT apart, Total = both.
export const erpInvoiceToLine = (inv, emptyItem = {}) => {
  const isUSD = String(inv?.currency || "VND").toUpperCase() === "USD";
  const net = Number(inv?.amount) || 0;
  const vat = Number(inv?.vat) || 0;
  return {
    ...emptyItem,
    inv_date: isoToDate(inv?.inv_date),
    inv_no: inv?.inv_no || "",
    description: inv?.description || "",
    amount_vnd: isUSD ? 0 : net,
    amount_usd: isUSD ? net : 0,
    vat,
    total: net + vat,
  };
};
